module.exports = __webpack_public_path__ + "static/media/logo-white.28366052.svg";